import React from "react";
const HtmlPluginContext = React.createContext(null);
const HtmlPluginContextProvider = ({ children }) => {
  const [state, setState] = React.useState({});
  const value = React.useMemo(
    () => ({
      state,
      setState
    }),
    [state, setState]
  );
  return /* @__PURE__ */ React.createElement(HtmlPluginContext.Provider, { value }, children);
};
const useHtmlPluginContext = () => {
  const context = React.useContext(HtmlPluginContext);
  if (!context) {
    throw new Error("useHtmlPluginContext must be used within HtmlPluginContextProvider");
  }
  return context;
};
export {
  HtmlPluginContext,
  HtmlPluginContextProvider,
  useHtmlPluginContext
};
//# sourceMappingURL=context.js.map
